import { api } from '../../../shared/services/api/client';

export const getAllCustomers = () => {
    return api.get('/merchant/customer-passes');
};

export const deleteCustomer = (passId) => {
    return api.delete(`/merchant/customer-passes/${encodeURIComponent(passId)}`);
};

export const getCustomerRewards = (passId) => {
    return api.get(`/customer/pass/rewards/${encodeURIComponent(passId)}`);
};

export const checkCustomerStatus = (email, signupToken = null) => {
    // Single endpoint handles both authenticated and unauthenticated calls
    const params = { email };
    if (signupToken) {
        params.signupToken = signupToken;
    }
    return api.get('/merchant/customer-passes/check-status', {
        params
    });
};
